const animeList = [
  {
    title: "星空旅人",
    tag: "热血·冒险",
    score: "9.2",
    img: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20a%20group%20of%20teen%20space%20travelers%20standing%20under%20a%20glowing%20night%20sky%20with%20shooting%20stars%2C%20warm%20coral%20and%20golden%20toned%20lighting%2C%20dynamic%20composition%2C%20high%20detail%20digital%20anime%20art%2C%20adventure%20mood&width=600&height=450&seq=anime-card-01&orientation=landscape",
  },
  {
    title: "热血骑士团",
    tag: "战斗·成长",
    score: "9.5",
    img: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20brave%20young%20knights%20in%20shining%20armor%20with%20a%20great%20castle%20and%20burning%20flame%20skyline%2C%20warm%20orange%20and%20red%20palette%2C%20epic%20heroic%20pose%2C%20high%20detail%20digital%20anime%20art%2C%20powerful%20battle%20energy&width=600&height=450&seq=anime-card-02&orientation=landscape",
  },
  {
    title: "甜甜小食堂",
    tag: "日常·治愈",
    score: "9.0",
    img: "https://readdy.ai/api/search-image?query=cozy%20anime%20illustration%20of%20a%20warm%20little%20cafe%20with%20friendly%20cooking%20character%20serving%20steaming%20bowls%20of%20food%2C%20soft%20warm%20amber%20and%20peach%20lighting%2C%20cute%20healing%20atmosphere%2C%20high%20detail%20digital%20anime%20art%2C%20gentle%20and%20relaxing%20mood&width=600&height=450&seq=anime-card-03&orientation=landscape",
  },
  {
    title: "未来侦探社",
    tag: "科幻·悬疑",
    score: "9.3",
    img: "https://readdy.ai/api/search-image?query=anime%20key%20visual%20of%20young%20detectives%20investigating%20a%20futuristic%20city%20with%20holographic%20screens%2C%20warm%20teal%20and%20gold%20neon%20tones%2C%20suspenseful%20yet%20playful%20mood%2C%20high%20detail%20digital%20anime%20art%2C%20mystery%20atmosphere&width=600&height=450&seq=anime-card-04&orientation=landscape",
  },
];

const genres = ["热血", "冒险", "日常", "治愈", "科幻", "悬疑", "恋爱", "搞笑"];

export default function Popular() {
  return (
    <section id="popular" className="w-full bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="inline-flex items-center gap-1.5 whitespace-nowrap rounded-full bg-accent-100 px-3 py-1 text-xs font-medium text-accent-700">
              <i className="ri-fire-line"></i> 热门内容
            </span>
            <h2 className="mt-4 font-heading text-3xl text-foreground-950 md:text-4xl">
              本周人气番剧推荐
            </h2>
            <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
              登录动漫之家即可观看上述人气番剧，收藏订阅、实时追更。换网址后记得重新登录，
              同步你的追番列表。
            </p>
          </div>
          <div className="flex flex-wrap items-center gap-2">
            {genres.map((g) => (
              <button
                key={g}
                type="button"
                className="whitespace-nowrap rounded-full border border-background-300 bg-background-50 px-4 py-1.5 text-sm text-foreground-700 transition-colors hover:border-secondary-400 hover:bg-secondary-100"
              >
                {g}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-10 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {animeList.map((a) => (
            <article
              key={a.title}
              className="group overflow-hidden rounded-xl border border-background-200 bg-background-50 transition-transform duration-300 hover:-translate-y-1"
            >
              <div className="relative h-44 w-full overflow-hidden md:h-48">
                <img
                  src={a.img}
                  alt={`${a.title}动画海报`}
                  className="h-full w-full object-cover transition-transform duration-300 group-hover:scale-105"
                />
                <span className="absolute right-3 top-3 inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-background-50/90 px-2.5 py-1 text-xs font-medium text-foreground-800">
                  <i className="ri-star-fill text-accent-500"></i>
                  {a.score}
                </span>
              </div>
              <div className="p-4">
                <div className="flex items-center justify-between">
                  <h3 className="text-base font-bold text-foreground-950">{a.title}</h3>
                  <span className="whitespace-nowrap rounded-full bg-secondary-100 px-2.5 py-1 text-xs text-secondary-900">
                    {a.tag}
                  </span>
                </div>
                <a
                  href="#access"
                  className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700"
                >
                  去追番
                  <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}